var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        { attrs: { label: "提示文字" } },
        [
          _c("el-input", {
            attrs: {
              size: "small",
              placeholder: "请设置提示语",
              maxlength: "50",
              "show-word-limit": "",
            },
            model: {
              value: _vm.value.placeholder,
              callback: function ($$v) {
                _vm.$set(_vm.value, "placeholder", $$v)
              },
              expression: "value.placeholder",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "单位" } },
        [
          _c("el-input", {
            attrs: {
              size: "small",
              placeholder: "请输入",
              maxlength: "12",
              "show-word-limit": "",
            },
            model: {
              value: _vm.value.unit,
              callback: function ($$v) {
                _vm.$set(_vm.value, "unit", $$v)
              },
              expression: "value.unit",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "小数位数" } },
        [
          _c("el-input-number", {
            attrs: {
              "controls-position": "right",
              precision: 0,
              max: 3,
              min: 0,
              size: "small",
              placeholder: "小数位数",
            },
            model: {
              value: _vm.value.precision,
              callback: function ($$v) {
                _vm.$set(_vm.value, "precision", $$v)
              },
              expression: "value.precision",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }